import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { LeadRawValue } from 'src/app/core/models/lead/lead-raw-value.model';
import { copiedToClipboard, copiedToClipboardError } from 'src/app/shared/utils/events/copied-to-clipboard.action';

@Component({
    selector: 'app-lead-received-info-dialog',
    templateUrl: './lead-received-info-dialog.component.html',
    styleUrls: ['./lead-received-info-dialog.component.scss'],
    standalone: false
})
export class LeadReceivedInfoDialogComponent implements OnInit {

  hasInfo: boolean = true
  dataSource: MatTableDataSource<LeadRawValue>
  filterForm = new FormControl<string>('')

  constructor(private readonly appStore: Store,
    public dialogRef: MatDialogRef<LeadReceivedInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public input: LeadRawValue[]) {
    this.hasInfo = input.length > 0
    this.dataSource = new MatTableDataSource(this.input)
    this.dataSource.filterPredicate = (item, s) => item.value.toLowerCase().includes(s.toLowerCase()) || item.description.toLowerCase().includes(s.toLowerCase())
  }

  ngOnInit(): void {
    this.filterForm.valueChanges.subscribe(value => this.dataSource.filter = value!.trim())
  }

  onClipboardCopy(success: boolean) {
    success ? this.appStore.dispatch(copiedToClipboard()) : this.appStore.dispatch(copiedToClipboardError())
  }

  displayedColumns: string[] = ['label', 'value']
}
